export enum CalloutIntent {
  None = "default",
  Info = "info",
  Success = "success",
  Warning = "warning",
  Danger = "danger",
}
